/**
 * 排班出勤侧栏（Overseas patch 212）
 */
export const WORKFORCE_MENU_IDS = {
  group: 990170,
  weekSchedule: 990171,
  clock: 990172,
  summary: 990173,
  weekScheduleView: 990174,
  clockAction: 990175,
  summaryView: 990176,
  smartRoster: 990177,
  mySchedule: 990178,
  payroll: 990179,
  smartRosterRun: 990180,
  myScheduleView: 990181
}

export default WORKFORCE_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/workforce.js